var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartmobilePop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95455 16.5C7.33111 16.5 7.63637 16.1642 7.63637 15.75C7.63637 15.3358 7.33111 15 6.95455 15C6.578 15 6.27274 15.3358 6.27274 15.75C6.27274 16.1642 6.578 16.5 6.95455 16.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4546 16.5C14.8311 16.5 15.1364 16.1642 15.1364 15.75C15.1364 15.3358 14.8311 15 14.4546 15C14.078 15 13.7727 15.3358 13.7727 15.75C13.7727 16.1642 14.078 16.5 14.4546 16.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.75H4.22727L6.05455 10.7925C6.11689 11.1378 6.28766 11.448 6.53696 11.6687C6.78626 11.8895 7.0982 12.0067 7.41818 12H14.0455C14.3654 12.0067 14.6774 11.8895 14.9267 11.6687C15.176 11.448 15.3467 11.1378 15.4091 10.7925L16.5 4.5H4.90909",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartmobilePop);
export default __webpack_public_path__ + "static/media/cartmobilePop.3554a0ccc79c16f374dc197f168f65b2.svg";
export { ForwardRef as ReactComponent };